module.exports = __webpack_public_path__ + "img/cleat.ffce55fd.jpg";